<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="500px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <!-- v-on="on" -->
      <v-btn
        color="error"
        :icon="!block"
        :block="block"
        :small="!block"
        v-bind="attrs"
        v-on="on"
      >
        <slot name="DeleteBtn">
          <v-icon color="error" small>fas fa-trash-alt</v-icon>
        </slot>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar color="error darken-3 white--text" dense class="mb-3">
        <v-toolbar-title>
          <slot name="title">
            Delete Form
          </slot>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="Cancel">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- <h1>Hellow</h1> -->
      <v-card-text>
        <h3 class="text-center title hosdhig mb-2">
          Are you Sure to Delete
          <span><v-icon color="error">fas fa-question</v-icon></span>
        </h3>
        <slot>
          <h1 class="text-center">
            <v-icon large color="error">far fa-flushed</v-icon>
          </h1>
        </slot>
        <p v-html="msgErr" class="text-center mt-3 error--text"></p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="isloading" @click="Cancel" color="success"
          >Cancel</v-btn
        >
        <v-btn :loading="isloading" @click="OnDelete" color="error"
          >Delete</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    DelQuery: { type: Object, required: true },
    DelUrl: { type: String, required: true },
    OnFinish: { type: Function, required: true },
    block: { type: Boolean, default: false },
  },
  data() {
    return {
      dialog: false,
      isloading: false,
      msgErr: "",
    };
  },
  methods: {
    OnDelete() {
      this.msgErr = "";
      this.isloading = true;
      this.$store
        .dispatch("DELETE", {
          url: this.DelUrl,
          data: this.DelQuery,
        })
        .then(result => {
          if (result && result.data) this.OnFinish(result.data, true);
          else this.OnFinish();
          this.Cancel();
        })
        .catch(err => {
          console.log(err);
          this.msgErr = err.response.data;
        })
        .finally(() => {
          this.isloading = false;
          // console.log("Final");
        });
    },
    Cancel() {
      this.dialog = false;
      this.msgErr = "";
    },
  },
};
</script>
<style scoped>
.hosdhig {
  /* border-bottom: solid double 2px black; */
  border-bottom: solid black;
}
</style>
